export default __webpack_public_path__ + "static/media/Bing.2faf5112.jpg";